import type { SubscriptionId } from '../../api';

/** Route of E7 in the router (M2 R1). */
export const CHANNEL_SETTINGS_ROUTE = '/channels/:subscriptionId/settings';

/**
 * Link to E7 for one subscription. Home and the Channels tab build their links with it, so the
 * link and the route can never drift apart (M2 R1, M1 §5.3 `homeLinks.channelSettings`).
 */
export function channelSettingsPath(subscriptionId: SubscriptionId): string {
  return `/channels/${encodeURIComponent(subscriptionId)}/settings`;
}
